import React from 'react';
import { Modal } from '@mantine/core';
import { Button } from '../../../../components/Button';
import navyModal from '../../../../components/Modal/navy-modal.module.scss';
import classes from './manager-table-join-confirm-modal.module.scss';

export type ManagerTableJoinConflict = {
  tableId: number;
  tableLabel: string;
  employeeName?: string;
};

type Props = {
  conflict: ManagerTableJoinConflict | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ManagerTableJoinConfirmModalComponent: React.FC<Props> = ({ conflict, isSubmitting, onConfirm, onCancel }) => (
  <Modal
    opened={conflict !== null}
    onClose={() => {
      if (!isSubmitting) onCancel();
    }}
    title={<strong>השולחן תפוס</strong>}
    centered
    radius="md"
    withCloseButton={false}
    closeOnClickOutside={!isSubmitting}
    closeOnEscape={!isSubmitting}
    classNames={{ root: navyModal.root, body: classes.body }}
  >
    <div className={classes.content} dir="rtl">
      <div className={classes.messageRow}>
        <span className={classes.icon} aria-hidden="true">↔</span>
        <strong>{conflict?.employeeName ? `${conflict.employeeName} עובד/ת כרגע בשולחן` : 'עובד/ת כרגע בשולחן'}</strong>
      </div>
      <p className={classes.description}>אפשר להיכנס לשולחן במקביל ולהמשיך לעבוד בו.</p>
      <div className={classes.actions}>
        <Button variant="cancel" fullWidth onClick={onCancel} disabled={isSubmitting} dataTestId="manager-table-join-cancel">ביטול</Button>
        <Button variant="confirm" fullWidth onClick={onConfirm} loading={isSubmitting} dataTestId="manager-table-join-confirm">אישור</Button>
      </div>
    </div>
  </Modal>
);

export const ManagerTableJoinConfirmModal = React.memo(ManagerTableJoinConfirmModalComponent);